import { css } from 'styled-components';
import colors from '../../../constants/COLORS';

const commonInputStyles = css`
  padding: 8px;
  background: #fff;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  font-size: 16px;
  box-sizing: border-box;
  outline: none;
  box-shadow: none;

  &:hover {
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.5);
  }

  &:focus {
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.8);
  }
`;

interface marketplaceInputStylesProps {
  textarea?: boolean;
}

const marketplaceInputStyles = css<marketplaceInputStylesProps>`
  padding: ${({ textarea }) => (textarea ? '10px 14px 0' : '14px 14px 0')};
  width: 100%;
  height: 48px;
  box-sizing: border-box;
  border-radius: 2px;
  font-size: 16px;
  color: ${colors.MARKETPLACE_BLACK};
  transition: all 0.2s ease-in-out;
  outline: none;
  border: 1px solid ${colors.MARKETPLACE_DARK_GREY};
  background-color: ${colors.WHITE};

  &::placeholder {
    color: ${colors.MARKETPLACE_DARK_GREY};
    transition: all 0.2s ease-in-out;
  }

  &:focus,
  &:not(:disabled):hover {
    border-color: ${colors.MARKETPLACE_BLACK};
    background-color: ${colors.WHITE};
  }

  &:focus::placeholder {
    opacity: 0;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

const marketplaceBlueInputStyles = css`
  &:focus,
  &:not(:disabled):hover {
    border-color: ${colors.MARKETPLACE_BLACK};
    box-shadow: 0;
  }
`;

export { commonInputStyles, marketplaceInputStyles, marketplaceBlueInputStyles };
